import { IGroupRoute } from "./IGroupRoute";
import { IState } from "../vuex/IState";
import { PageTypes } from "./PageTypes";
import { Routing } from "@timesheets/webapp-support";
import { Store } from "vuex";
import { TRouteMetaGroup } from "./TRouteMetaGroup";
import { WebApplicationConstants } from "@/setup/WebApplicationConstants";
import { WireEntities } from "@timesheets/common";
import { getBestRole } from "./getBestRole";
import { redirectToRolesList } from "./redirectToRolesList";
import { redirectToTimesheetsWhenOnlyOneRole } from "./redirectToTimesheetsWhenOnlyOneRole";

export function ensureRoleForRoute(route: IGroupRoute, PageType: PageTypes, store: Store<IState>): Routing.RouteResult<TRouteMetaGroup> {
  // Pass on to the next route, by default
  let routeResult: Routing.RouteResult<TRouteMetaGroup> = { continue: true, route: undefined };
  let userRole: WireEntities.Roles.IRecruitmentAgencyRole | undefined = undefined;

  const enabledRoles = store.getters["user/enabledRoles"] as WireEntities.Roles.IRecruitmentAgencyRole[];
  if (enabledRoles) {
    if (route.searchTerms.roleId) {
      // Is there a role id and is this role a role for the user
      userRole = enabledRoles.find(role => role.id === route.searchTerms.roleId);
    }

    if (!userRole) {
      userRole = getBestRole(store.state.currentSession, enabledRoles);
      if (userRole) {
        routeResult = { continue: true, route };
      }
    }

    if (!routeResult.route) {
      if (userRole) {
        routeResult = redirectToTimesheetsWhenOnlyOneRole(PageType, enabledRoles, userRole, route);
      } else {
        routeResult = redirectToRolesList(PageType, route);
      }
    }
  } else {
    routeResult = redirectToRolesList(PageType, route);
  }

  if (userRole && userRole.recruitmentAgency.names.currentCanonical !== WebApplicationConstants.currentTenant) {
    routeResult = { continue: false, route, location: { action: Routing.RouteAction.Assign, schemeAndAuthority: userRole.recruitmentAgency.settings.portalUrl.internal } };
  }

  if (route.path.startsWith("/login")) {
    routeResult = redirectToRolesList(PageType, route, userRole);
  }

  Routing.ensureRoleIdOnUrl(route, store.state.user.currentRole, userRole && userRole.id);

  if (routeResult.continue) {
    store.dispatch("user/setCurrentRole", { role: userRole });
  }

  return routeResult;
}
